<template>
  <b-modal no-fade v-model="dialog.show" size="xl" :ref="`modal-client-${uniqueId}`"
           :id="`modal-client-basic-${uniqueId}`"
           :hide-footer="true" centered @show="closeAllPopovers" @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
  <span v-if="loading !== true && error == null && client != null">
    <!-- Online/offline indicator -->
    <i
        class="fa-solid fa-circle text-success client-action-icon"
        v-if="client.online"
        v-b-tooltip.hover
        title="online"
    ></i>
    <i
        class="fa-solid fa-circle text-danger client-action-icon"
        v-else
        v-b-tooltip.hover
        title="offline"
    ></i>

    <!-- Client name -->
    <span class="text-capitalize">{{ client.firstName }} {{ client.lastName }}</span>

    <!-- === BALANCE & CREDIT SECTION === -->
    <template class="align-content-center">
    <span class="ml-1 mr-1 text-muted">|</span>
    <span class="font-weight-bold"><i class="fa-solid fa-coins text-warning mr-1"></i>{{ $t('columns.balance') }}: <span
        class="text-success"
    >{{ convertToEURO(client.totalBalance) }}</span></span>
    <span class="ml-2"><i class="fa-solid fa-credit-card text-info mr-1"></i>{{ $t('columns.credit') }}: <span
        class="text-primary"
    >{{ convertToEURO(client.totalCredit) }}</span></span>
      </template>
  </span>

      <!-- New client -->
      <span v-if="id == null">
    {{ $t('tabs.clients.newClient') }}
  </span>
    </template>

    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <client-details v-model="client" disable-management small>
          <template #button="{update}">
            <b-row >
              <b-col cols="12"><hr/></b-col>
              <b-col cols="1"><b-button block variant="primary" @click="update"><i class="fa-solid fa-floppy-disk"></i></b-button></b-col>
              <b-col cols="10"><b-button style="min-width: 50%" variant="primary" @click="updateAndNext(update)">{{$t('operations.saveAndNext')}}</b-button></b-col>
              <b-col cols="1"><b-button block variant="warning" @click="nextClient"><i class="fa-solid fa-angle-right"></i></b-button></b-col>
            </b-row>
          </template>
        </client-details>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%"
           v-else-if="loading !== true && error != null"
      >
        <b-alert show variant="danger">
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{ $t('operations.loading') }}</b-spinner>
      </div>
    </div>

  </b-modal>


</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import ClientDetails from '@/components/partial/clients/ClientEditDetails';
import mixinBase from '@/components/mixin/mixinBase';
import Notes from '@/components/partial/notes/notes';
import ClientAccounts from '@/components/partial/accounts/ClientAccounts';
import ClientMonetaryTable from '@/components/tables/ClientMonetariesTable';
import mixinPopover from '@/components/mixin/mixinPopover';
import ClientNewDetails from '@/components/partial/clients/ClientNewDetails.vue';
import KycTable from '@/components/tables/KycTable';
import LogTable from '@/components/tables/LogTable.vue';

export default {
  name: 'clientModalBasic',
  mixins: [mixinBase, mixinNotifications, mixinPopover],
  components: {
    LogTable,
    KycTable,
    ClientNewDetails,
    ClientMonetaryTable,
    ClientAccounts,
    Notes,
    ClientDetails
  },
  data: () => ({
    dialog: {
      show: false,
      tab: 0,
    },

    selectedBranch: null,
    selectedManager: null,
    newEmail: '',
    kycFilter: {},
    logFilter: {},
    kycColumns: [],
    logColumns: [],
    uniqueId: 0,
    loading: true,
    reLoading: true,
    loadingToken: false,
    error: null,
    id: null,
    client: null,
    branches: null,
    users: null,

  }),
  watch: {
    ['dialog.tab']() {
      if (this.client != null && this.loading !== true && this.queryParams().tab !== this.dialog.tab) {
        this.pushState({ tab: this.dialog.tab });
      }
    },
    queryParams: {
      handler() {
        if (this.queryParams().clientId == null) {
          this.closeModal();
          return;
        }
        if (this.queryParams().clientId !== this.id) {
          this.showModal(this.queryParams().clientId);
        } else if (this.queryParams().tab !== this.dialog.tab) {
          this.dialog.tab = !isNaN(this.queryParams().tab) ? parseInt(this.queryParams().tab) : 0;
        }

      },
      deep: true
    },
    ['client.id']() {
      if (this.client != null && this.client.id != null) {
        this.pushState({ clientId: this.client.id });
        this.id = this.client.id;

        this.kycFilter = {
          clientId: this.client.id
        };
        this.logFilter = {
          id: this.client.id
        };
      }
    }
  },
  mounted() {
    this.$root.$on('open-client-modal', this.handleExternalOpen);
    this.$root.$on('system::account::update', this.onAccountChange);
  },
  beforeDestroy() {
    this.$root.$off('open-client-modal', this.handleExternalOpen);
    this.$root.$off('system::account::update', this.onAccountChange);
  },

  computed: {
    ...mapGetters('data', ['allUsers', 'allBusinessUnits']),
  },
  created() {
    this.uniqueId = this._uid;
    if (this.queryParams().client != null) {
      this.showModal(this.queryParams().client);
    }
  },
  methods: {
    ...mapActions('clients', ['getClientById', 'duplicateClient', 'getClientToken', 'promoteClient']),
    showModal(id) {
      console.log('showModal-> client basic', { id });
      if (id == null) {
        console.warn("Cannot open client modal basic without id");
        return;
      }
      this.id = id;
      this.loading = true;
      this.dialog.show = true;
      this.refreshData();
      this.loading = true;
      this.pushState({
        clientId: id,
        tab: this.dialog.tab,
      });
    },
    closeModal() {
      this.dialog.show = false;
      this.client = {};
      this.onDialogClose();
    },
    onDialogClose() {
      this.id = null;
      this.pushState({
        clientId: null,
        tab: null,
      });
      this.$emit('closed')
    },
    refreshData() {
      let $this = this;
      this.reLoading = true;
      let currentTab = !isNaN(this.queryParams().tab) ? parseInt(this.queryParams().tab) : 0;
      this.getClientById(this.id)
          .then(client => {
            $this.client = client;
            $this.error = null;
            $this.loading = false;
            $this.reLoading = false;
            setTimeout(() => {
              $this.dialog.tab = currentTab;
            }, 500);
          }, err => {
            $this.error = $this.getErrorDescription(err);
            $this.loading = false;
            $this.reLoading = false;
          });
    },
    updateAndNext(updateFunc) {
      let $this = this;
      updateFunc().then(() => {
            $this.$emit('client-updated', $this.client);
            $this.nextClient();
          });
    },
    nextClient() {
      this.$emit('next-client');
    },


  },
};
</script>

<style scoped>

</style>
